import React from "react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Moon, Sun, Monitor, Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const THEME_OPTIONS = [
  { value: "light", label: "Lys", icon: Sun, description: "Alltid lys bakgrunn" },
  { value: "dark", label: "Mørk", icon: Moon, description: "Rolig mørk modus for kveldsbruk" },
  { value: "system", label: "System", icon: Monitor, description: "Følger innstillingen på enheten" },
];

export const ThemeToggle = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const Icon = resolvedTheme === "dark" ? Moon : Sun;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Bytt fargetema" data-testid="theme-toggle-button">
          <Icon className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card w-44">
        {THEME_OPTIONS.map((o) => (
          <DropdownMenuItem key={o.value} onClick={() => setTheme(o.value)} data-testid={`theme-option-${o.value}`}>
            <o.icon className="h-4 w-4 mr-2" /> {o.label}
            {theme === o.value ? <Check className="h-4 w-4 ml-auto text-primary" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

/** Kortbasert velger for innstillingssiden. */
export const ThemeChooser = () => {
  const { theme, setTheme } = useTheme();
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Fargetema">
      {THEME_OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={theme === o.value}
          onClick={() => setTheme(o.value)}
          className={cn("rounded-lg border p-3 text-left transition-colors hover:bg-secondary", theme === o.value && "border-primary bg-accent text-accent-foreground")}
          data-testid={`theme-chooser-${o.value}`}
        >
          <o.icon className="h-4 w-4 mb-2" />
          <p className="text-sm font-medium">{o.label}</p>
          <p className="text-[11px] text-muted-foreground leading-snug">{o.description}</p>
        </button>
      ))}
    </div>
  );
};
